import { ApiProperty } from '@nestjs/swagger';
import { OffsetPaginationResponseDto } from '@sphere/shared/domain';
import { LearningPathResponseDto } from './learning-path.response';

export class LearningPathListResponseDto extends OffsetPaginationResponseDto<LearningPathResponseDto> {
  @ApiProperty({ type: () => [LearningPathResponseDto] })
  declare data: LearningPathResponseDto[];
}

